export default "/_next/static/b090b6501353c07cdbaaec84baeed872.png";